import { useMemo } from "react";

import Stack from "@mui/material/Stack";

import { TableFilterBar } from "../../../Components/FilterTable/Filterbar/TableFilterBar";
import { type KnownIssue } from "../types";
import { onlyOngoingKnownIssuesFilter, platformColumn, productColumn, statusColumn, titleColumn } from "./consts";

type Props = {
  knownIssues: KnownIssue[];
  onFilter: (filterFunction?: (issuesList: KnownIssue[]) => KnownIssue[]) => void;
};

export const KnownIssuesFilterbar = ({ knownIssues, onFilter }: Props) => {
  const columns = useMemo(() => [statusColumn, platformColumn, productColumn, titleColumn], []);
  return (
    <Stack
      direction="row"
      sx={{
        px: 2,
        borderColor: "general.divider",
        borderStyle: "solid",
        borderWidth: 1,
        borderTopLeftRadius: 4,
        borderTopRightRadius: 4,
        borderBottom: "none",
        justifyContent: "space-between",
        alignItems: "center",
        flex: 1,
        marginBottom: 0,
      }}
    >
      <TableFilterBar
        items={knownIssues}
        filterColumn={columns}
        onFilter={onFilter}
        placeholder="Filter Cloud Incidents"
        defaultFilters={[onlyOngoingKnownIssuesFilter]}
      />
    </Stack>
  );
};
